import './About.css';

export default function About() {
    return `
        <section id="about" class="about">
            <div class="container about__container">

                <div class="about__left">

                    <h2 class="about__title">
                        About
                    </h2>

                    <p>
                        The Perspectives In Ergodic Theory, RandOmness and GeometrY conference will focus on exploring interactions of probabilistic and ergodic methods in broadly understood geometry.
                    </p>

                    <div class="about__additional-info">

                        <div class="about__dioscuri">
                            <p>
                                The PIEROGY 2027 conference is held as a part of the Dioscuri Center for Scientific Excellence project. The Dioscuri Centre “Random Walks in Geometry and Topology" at the Jagiellonian University in Kraków, established in September 2023, is led by dr Mikołaj Frączyk, with collaboration from prof. Roman Sauer of the Karlsruhe Institute of Technology. Funded by the Dioscuri Programme, a joint initiative of the Max Planck Society and the National Science Centre Poland, the Centre focuses on advancing research in:
                            </p>

                            <ul>
                                <li>discrete subgroups of higher-rank semi-simple Lie groups</li>
                                <li>growth of topological and arithmetic invariants in finite-volume locally symmetric spaces</li>
                                <li>automorphic forms and spectral theory of locally symmetric spaces</li>
                                <li>ergodic theory related to mapping class group actions</li>
                                <li>applications of random processes in geometric and measured group theory</li>
                            </ul>
                        </div>

                        <p>
                            <a
                                href="https://pierogy.matinf.uj.edu.pl/"
                                class="about__link"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                The previous PIEROGY conference took place on 12–16 January 2026 in Kraków
                                <span class="about__link-arrow">&rarr;</span>
                            </a>
                        </p>
						<p class="about__contact">
                            Contact: <a href="mailto:pierogy@matinf.uj.edu.pl">
                                pierogy@matinf.uj.edu.pl <span class="about__link-arrow">&rarr;</span>
                            </a>
                        </p>
                        
                        <p class="about__contact">
                            Administrative support: <a href="mailto:patrycja.bien@uj.edu.pl">
                                patrycja.bien@uj.edu.pl <span class="about__link-arrow">&rarr;</span>
                            </a>
                        </p>

                        
						  <p class="about__dioscuri-statement">
                        “Dioscuri Centres of Scientific Excellence. A programme initiated by the Max Planck Society (MPG), jointly managed with the National Science Centre in Poland (NCN), and mutually funded by the Ministry of Science and Higher Education (MNiSW) and the Federal Ministry of Research, Technology and Space (BMFTR)”
                    </p>
                    </div>

                </div>

            </div>
        </section>
    `;
}
